// 스크롤로 화면에 들어오면 부드럽게 나타나는 효과 (v-reveal)
export default {
    install(app) {
        const supported = typeof window !== 'undefined' && 'IntersectionObserver' in window
        const observer = supported
            ? new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible')
                        observer.unobserve(entry.target)
                    }
                })
            }, { threshold: 0.12 })
            : null

        app.directive('reveal', {
            mounted(el) {
                if (!observer) return
                el.classList.add('reveal')
                observer.observe(el)
            },
            unmounted(el) {
                if (observer) observer.unobserve(el)
            }
        })
    }
}
